(() => {
  if (window.poshtikCartOfferCopyReady) return;
  window.poshtikCartOfferCopyReady = true;

  const copyText = async (value) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    document.execCommand('copy');
    field.remove();
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-discount-copy]');
    if (!button) return;

    const label = button.querySelector('span');
    const code = button.dataset.cartDiscountCopy;

    try {
      await copyText(code);
      button.classList.add('is-copied');
      label.textContent = 'Copied!';
      window.setTimeout(() => {
        button.classList.remove('is-copied');
        label.textContent = 'Copy code';
      }, 1800);
    } catch (error) {
      label.textContent = code;
    }
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-recommendation-add]');
    if (!button || button.disabled) return;

    const cartDrawer = document.querySelector('cart-drawer');
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    label.textContent = 'Adding…';

    try {
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.cartRecommendationAdd), quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Unable to add product');
      cartDrawer.renderContents(result);
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      label.textContent = 'Try again';
      window.setTimeout(() => {
        label.textContent = originalLabel;
      }, 1800);
    }
  });

  let recommendationDrag = null;
  let suppressRecommendationClickUntil = 0;

  document.addEventListener('pointerdown', (event) => {
    const rail = event.target.closest('.poshtik-cart-recommendations__list');
    if (!rail || event.pointerType !== 'mouse' || event.button !== 0) return;

    recommendationDrag = {
      rail,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScrollLeft: rail.scrollLeft,
      moved: false,
    };
    rail.setPointerCapture(event.pointerId);
    rail.classList.add('is-dragging');
  });

  document.addEventListener('pointermove', (event) => {
    if (!recommendationDrag || event.pointerId !== recommendationDrag.pointerId) return;

    const distance = event.clientX - recommendationDrag.startX;
    if (Math.abs(distance) > 4) recommendationDrag.moved = true;
    recommendationDrag.rail.scrollLeft = recommendationDrag.startScrollLeft - distance;
    if (recommendationDrag.moved) event.preventDefault();
  });

  const finishRecommendationDrag = (event) => {
    if (!recommendationDrag || event.pointerId !== recommendationDrag.pointerId) return;

    const { rail, moved, pointerId } = recommendationDrag;
    if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
    rail.classList.remove('is-dragging');
    if (moved) suppressRecommendationClickUntil = Date.now() + 250;
    recommendationDrag = null;
  };

  document.addEventListener('pointerup', finishRecommendationDrag);
  document.addEventListener('pointercancel', finishRecommendationDrag);

  document.addEventListener(
    'click',
    (event) => {
      if (
        Date.now() < suppressRecommendationClickUntil &&
        event.target.closest('.poshtik-cart-recommendations__list')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
})();
